import DenyReasonPanel from './DenyReasonPanel';
export default DenyReasonPanel;